import React from 'react';
import HeaderPolicity from '../components/HeaderPolicity';

export default function PrivacyPolicy() {
    return (
        <>
            <HeaderPolicity />
            <div className='min-h-screen flex flex-col items-center justify-center bg-gray-100 p-4'>

                <div className='bg-white rounded-lg shadow-lg p-6 max-w-3xl w-full'>
                    <h1 className='text-3xl font-bold mb-4'>Política de Privacidade</h1>
                    <p className='mb-4'>
                        Nos comprometemos a proteger sua privacidade, garantindo que suas informações pessoais não serão alugadas, vendidas ou distribuídas para terceiros.
                    </p>
                    <p className='mb-4'>
                        O uso dos sistemas do FonotherApp implica a aceitação desta política de privacidade.
                    </p>
                    <h2 className='text-2xl font-bold mb-2'>Sobre a Utilização das Informações Pessoais</h2>
                    <p className='mb-4'>
                        As informações coletadas sobre você e seu uso de nossos sistemas visam garantir que sua experiência seja a mais agradável possível.
                    </p>
                    <p className='mb-4'>
                        Podemos armazenar seu nome, número de telefone e endereço de email para entrar em contato com você ou autenticar sua conta no FonotherApp.
                    </p>
                    <p className='mb-4'>
                        As informações pessoais armazenadas por você no FonotherApp são confidenciais e acessíveis apenas por você e nossa equipe. Isso inclui todas as informações que você gerar utilizando o FonotherApp, como mensagens, áudios, imagens, vídeos, etc.
                    </p>
                    <p className='mb-4'>
                        Ao criar exercícios em formato de vídeo, áudio ou imagem em nossa plataforma ou aplicativos, as mídias são armazenadas em nossos servidores para que você possa compartilhá-las com seus pacientes quando desejar.
                    </p>
                    <p className='mb-4'>
                        Nos comprometemos a não vender, alugar ou repassar suas informações para terceiros, exceto quando exigido judicialmente.
                    </p>
                    <p className='mb-4'>
                        Apesar de adotarmos boas práticas de proteção e segurança, nenhum serviço web é 100% seguro contra invasões e não nos responsabilizamos caso isso ocorra.
                    </p>
                    <h2 className='text-2xl font-bold mb-2'>Sobre a Coleta de Informações</h2>
                    <p className='mb-4'>
                        As suas informações pessoais poderão ser coletadas através de:
                    </p>
                    <ul className='list-disc list-inside mb-4'>
                        <li>Fornecimento direto por você ao preencher qualquer formulário de contato ou em nossos sistemas.</li>
                        <li>
                            Uso e ações no nosso site ou sistemas: ao acessar nossos serviços, coletamos informações anônimas como: endereço de IP, tipo de dispositivo (computador ou móvel), tempo de permanência, região de origem, tipo de navegador e fonte de referência.
                        </li>
                    </ul>
                    <h2 className='text-2xl font-bold mb-2'>Sobre Modificações na Política de Privacidade</h2>
                    <p className='mb-4'>
                        Alterações neste documento podem ser realizadas, mas nós nos comprometemos a comunicar quaisquer mudanças que possam impactá-lo.
                    </p>
                </div>
            </div>

        </>
    );
}
